import { PlayPartner, ICanvasPartner } from '@/common/interfaces';
import { TWITTER_DIMENSIONS, FACEBOOK_DIMENSIONS, GOOGLE_DIMENSIONS, SNAPCHAT_DIMENSIONS, PINTEREST_DIMENSIONS, INSTAGRAM_DIMENSIONS } from '@/mocks/data/dimensions';

export const PLAY_PARTNER_LIST: PlayPartner[] = [{
  id: 21,
  maxFileSize: 5000000,
  maxFileSizeMB: 5,
  name: 'Default',
  templateSize: 302470,
}];

// https://digivizer.com/blog/social-media-ad-specs-2022/
// https://apidocs.dev.craftsmanplus.com/#tag/Creatives/operation/sizeCreative

export const CANVAS_PARTNER_LIST: ICanvasPartner[] = [
  {
    id: 1,
    name: 'Facebook',
    isEnabled: true,
    dimensions: FACEBOOK_DIMENSIONS,
  },
  {
    id: 2,
    name: 'Google',
    isEnabled: true,
    dimensions: GOOGLE_DIMENSIONS,
  },
  {
    id: 3,
    name: 'Snapchat',
    isEnabled: true,
    dimensions: SNAPCHAT_DIMENSIONS,
  },
  {
    id: 4,
    name: 'Pinterest',
    isEnabled: true,
    dimensions: PINTEREST_DIMENSIONS,
  },
  {
    id: 5,
    name: 'Applovin',
    isEnabled: false,
    dimensions: [],
  },
  {
    id: 6,
    name: 'Liftoff',
    isEnabled: false,
    dimensions: [],
  },
  {
    id: 7,
    name: 'Instagram',
    isEnabled: true,
    dimensions: INSTAGRAM_DIMENSIONS,
  },
  {
    id: 8,
    name: 'Twitter',
    isEnabled: true,
    dimensions: TWITTER_DIMENSIONS,
  },
];
export default PLAY_PARTNER_LIST;
